import React, { useEffect, useState } from "react";

import "../../../pages/navbar.css";
import "../../styles.css";
import { ReactComponent as Shieldlowrisk } from "../../../assets/TaxShieldReportsIcons/successIcon.svg";
import { ReactComponent as Shieldhighrisk } from "../../../assets/TaxShieldReportsIcons/CautionIcon.svg";
import {
  Container,
  Box,
  Grid,
  Grid2,
  Card,
  CardContent,
  Typography,
  Select,
  MenuItem,
  Divider,
  TableCell,
  TableRow,
  TableBody,
  TableHead,
  TableContainer,
  TablePagination,
  Button,
} from "@mui/material";
import { TaskRiskReport } from "./type";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import HighRiskIcon from "../../../assets/TaxShieldReportsIcons/HighRiskGuageIcon.svg";
import MediumIcon from "../../../assets/TaxShieldReportsIcons/MediumRiskGuageIcon.svg";
import LowRiskIcon from "../../../assets/TaxShieldReportsIcons/LowRiskGuageIcon.svg";
import { Auth } from "aws-amplify";
import { clientConfig } from "../../../awsClientConfig";
import PersonIcon from "@mui/icons-material/Person";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { fetchQuery, formatCurrency, formatPhone } from "../../../functions/misc";
import { Table } from "react-bootstrap";
import { userProfileData } from "../../../Common/profileInfo";
import { GetTaxRiskReports } from "../../../queries/GetTaxRiskReports";
import { getTaxRiskReport } from "../../../queries/getTaxRiskReport";
import { GetPartnerWithoutTaxProfessional } from "../../../queries/GetPartnerWithoutTaxProfessional";
import { GetPhoneNumbers } from "../../../queries/GetPhoneNumbers";
import moment from "moment";
import { TaxRiskReportItem } from "../../DashBoards/types";
import "./reportStyles.css";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import { paths } from "../../../paths";
import LegacyReports from "../TaxShieldLegacyReports/LegacyReports";
import { IsUserLegacy } from "../../../Common/LegacyLogin";
import { CustomerRoleName, useProfileStore, useRoleStore, EnrollmentSource } from "../../../store/ProfileStore";
import useEnrollmentStore, { ProtectionPlanName } from "../../../store/EnrollmentStore";
import PlaceholderReport from "./PlaceholderReport";
import { FeatureFlags } from "../../../types/featureFlags";
import { useFlags } from "launchdarkly-react-client-sdk";
import { TaxIdTheftAlertModal } from "../../../Common/tax-id-theft/tax-id-theft-alert-modal";
import { TaxIdTheftConfirmationModal } from "../../../Common/tax-id-theft/confirmation-modal";
import { TaxReturnNotFilingModal } from "../../../Common/tax-id-theft/tax-return-not-filiing-modal";
import { GetProfileAlerts } from "../../../queries/GetProfileAlerts";
import { TaxReturnNotFilingReferralModal } from "../../../Common/tax-id-theft/tax-return-not-filiing-referral-modal";
import { TaxReturnNotFilingSubscriberModal } from "../../../Common/tax-id-theft/tax-return-not-filiing-subscriber-modal";
import { GetLegacyTaxRiskReports } from "../../../queries/GetLegacyTaxRiskReports";
import { LeadSummary, LegacyTaxRiskReportItem } from '../../../API';
import { NoticeDisplayModal } from "./NoticeDisplayModal";
import { GetProfile } from "../../../queries/getProfile";
import { GetOrganization } from "../../../queries/GetOrganization";
import { CustomTooltip } from "../../../Common/CustomToolTip";

type TaxShieldReportsProps = {
  reportId?: string; 
  lead?: LeadSummary|null; 
};
const TaxShieldReports: React.FC<TaxShieldReportsProps> = ({ reportId, lead }) => {
  const client = new clientConfig();
  const { state:routeState } = useLocation();
  const [allTaxShieldReports, setAllTaxShieldReports] = useState<
    TaxRiskReportItem[]
  >([]);
  const [currentTaxSheildReportId, setCurrentTaxShieldReportId] =
    useState<string>("");
  const [taxShieldReport, setTaxShieldReport] = useState<TaskRiskReport>();
  const [clientName, setClientName] = useState("");
  const [partnerName, setPartnerName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [profileData, setProfileData] = useState<any>();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isLegacy, setIsLegacy] = useState(false);
  const [singleReportLoading, setSingleReportLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  const { customerRole } = useRoleStore();
  const [reportDate, setReportDate] = useState({
    Date: "",
    index: 0,
  });
  const [noticePage, setNoticePage] = useState(0);
  const [noticeRowsPerPage, setNoticeRowsPerPage] = useState(3);
  const [taxLiabilityPage, setTaxLiabilityPage] = useState(0);
  const [taxLiabilityRowsPerPage, setTaxLiabilityRowsPerPage] = useState(3);
  const [showPlaceholder, setShowPlaceholder] = useState<boolean>(false);
  const { protectionPlanEnrollment, taxPrepEnrollment } = useEnrollmentStore();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showDisagreeModal, setShowDisagreeModal] = useState(false);
  const flagList: FeatureFlags = useFlags();
  const [profileAlerts, setProfileAlerts] = useState<any[]>([]);
  const [legacyTaxReports, setLegacyTaxReports] = useState<LegacyTaxRiskReportItem[]>([]);
  const { partnerProfile, primaryProfile } = useProfileStore();
  const [selectedNotice, setSelectedNotice] = useState<any>();
  const [showNoticeModal, setShowNoticeModal] = useState(false);


   // Determine if we're in standalone (modal) mode
   const isStandalone = reportId !== undefined;
  
   // Use props if in standalone mode, otherwise use route state
   const activeTaxRiskReportId = isStandalone ? reportId : routeState?.taxRiskReportId;
   const activeLead = isStandalone ? lead : routeState?.lead;

   
  const RISk = {
    Low: {
      icon: LowRiskIcon,
      label: "Low Risk",
      title: "LOW RISK",
      buttonName: "Get Protected!",
      route: "",
      nextStep:
        "Congratulations! IRS records indicate that your account is in good standing. If anything changes, we will let you know.",
    },
    Medium: {
      icon: MediumIcon,
      label: "Medium Risk",
      title: "MEDIUM RISK",
      buttonName: "Get Protected!",
      route: "",
      nextStep: `Activity on your IRS account indicates you may be at risk for enforcement. Please contact your representative at ${phoneNumber} for more information.`,
    },
    High: {
      icon: HighRiskIcon,
      label: "High Risk",
      title: "HIGH RISK",
      buttonName: "Get a FREE Consultation",
      route: "",
      nextStep: `Based on our analysis you are at high risk of collection activity and/or audit review.`,
    },
  };

  const fetchSingleTaxReport = async (taxRiskReportId: string) => {
    setSingleReportLoading(true);
    await client
      .query({
        query: getTaxRiskReport,
        variables: {
          taxRiskReportId: taxRiskReportId,
        },
      })
      .then((res: any) => {
        setTaxShieldReport(res.data.GetTaxRiskReport);
      })
      .catch((error: any) => {
        if (error.data.GetTaxRiskReport) {
          error.data.GetTaxRiskReport.TaxLiabilitiesByYear =
            error.data.GetTaxRiskReport?.TaxLiabilitiesByYear?.filter(
              (entry: any) => entry !== null
            );
          setTaxShieldReport(error.data.GetTaxRiskReport);
        }
        console.log(error);
      })
      .finally(() => setSingleReportLoading(false));
  };

  const fetchGetTaxReports = async () => {
    setIsLoading(true);
    await Auth.currentAuthenticatedUser({ bypassCache: true });

    const profileId = await userProfileData();

    await client
      .query({
        query: GetTaxRiskReports,
        variables: { ProfileId: activeLead ? activeLead.ProfileId : profileId },
      })
      .then(async (res: any) => {
        if (res.data.GetTaxRiskReports !== null) {
          setAllTaxShieldReports(res.data.GetTaxRiskReports?.TaxRiskReports);
          const taxReports: any = res.data.GetTaxRiskReports?.TaxRiskReports;
          const taxRiskReportId = taxReports[0]?.Id;
          !activeTaxRiskReportId && setCurrentTaxShieldReportId(taxRiskReportId as string);
          setReportDate({ Date: taxReports[0]?.ReportDate, index: 0 });
        } else {
          setShowPlaceholder(true);
        }
      })
      .catch((error) => {
        console.log("error:", error);
      })
      .finally(() => setIsLoading(false));
  };

  const fetchPartnerInfo = async () => {
    if (partnerProfile) {
      setPhoneNumber(formatPhone(partnerProfile.Phone));
      setPartnerName(partnerProfile.FirstName + " " + partnerProfile.LastName);
      setClientName(activeLead.FirstName + (activeLead.MiddleName ? " " + activeLead.MiddleName : "") + " " + activeLead.LastName);
    }
  }

  const fetchClientName = async () => {
    setIsLoading(true);

    if (primaryProfile) {
      const firstName = primaryProfile.FirstName;
      const middleName = primaryProfile.MiddleName
        ? primaryProfile.MiddleName
        : "";
      const lastName = primaryProfile.LastName;
      setClientName(firstName + " " + middleName + " " + lastName);
      const getPhoneNumbers = await fetchQuery({}, GetPhoneNumbers);

      if (primaryProfile.EnrollmentSource === EnrollmentSource.Organic || primaryProfile.EnrollmentSource === EnrollmentSource.Legacy) {
        setPhoneNumber(formatPhone(getPhoneNumbers.ProfileContactUs));
        setPartnerName("Customer Service");
      } else if (primaryProfile.EnrollmentSource === EnrollmentSource.Referral) {
        const partnerId = primaryProfile.PartnerId;
        const getPartner = await fetchQuery({ partnerId }, GetPartnerWithoutTaxProfessional);

        if (getPartner) {
          setPhoneNumber(formatPhone(getPartner.Phone));
          setPartnerName(getPartner.FirstName + " " + getPartner.LastName);
        }
      }
    }

    const profileId = await userProfileData();
    const client = new clientConfig();
    client
      .query({
        query: GetProfile,
        variables: { profileId: profileId },
      })
      .then((res: any) => {
        if (res.data.GetProfile !== null) {
          setProfileData(res.data.GetProfile);
          if (res.data.GetProfile.EnrollmentSource === "Referral") {
            client
              .query({
                query: GetPartnerWithoutTaxProfessional,
                variables: {
                  PartnerId: res.data.GetProfile.PartnerId,
                },
              })
              .then((res: any) => {
                const organizationId = res.data.GetPartner.OrganizationId;

                if (organizationId) {
                  client
                    .query({
                      query: GetOrganization,
                      variables: { organizationId },
                    })
                    .then((res: any) => {
                      setPhoneNumber(
                        formatPhone(res.data.GetOrganization.Phone)
                      );
                      setPartnerName(res.data.GetOrganization.Name);
                    })
                    .catch((error: any) => {
                      console.log(error, "error");
                    });
                }
              });
          }
        }
      })
      .catch((error: any) => {
        console.log(error, "error");
      })
      .finally(() => { });

  };

  const dateformat = (date: string) => {
    if (date) {
      return moment(new Date(date)).utc().format("MMMM DD, YYYY");
    } else {
      return moment(new Date()).utc().format("MMMM DD, YYYY");
    }
  };

  const fetchTaxIDTheftAlerts = async () => {
    const profileId = await userProfileData();
    const  profileAlertsData = await fetchQuery({ ProfileId: profileId }, GetProfileAlerts);
    setProfileAlerts(profileAlertsData?.ProfileAlerts?.sort((alert1:any, alert2:any) => alert1.TaxYear - alert2.TaxYear));
  }

  useEffect(() => {
    if (partnerProfile) return;

    fetchLegacyTaxRiskReports();
    if (flagList?.featureTaxIdMonitor) {
      fetchTaxIDTheftAlerts();
    }
    fetchGetTaxReports();
    fetchClientName();
  }, []);

  useEffect(() => {
    if (activeTaxRiskReportId) {
      fetchSingleTaxReport(activeTaxRiskReportId);
      fetchGetTaxReports();
      fetchPartnerInfo();
    }
  }, [activeTaxRiskReportId]);

  const fetchLegacyTaxRiskReports = async () => {
    const legacyResponse = await IsUserLegacy();
    if (legacyResponse) {
      const profileId = await userProfileData();
      const getLegacyTaxRiskReports = await fetchQuery({ ProfileId: profileId, }, GetLegacyTaxRiskReports);

      if (getLegacyTaxRiskReports.length > 0) {
        setLegacyTaxReports(getLegacyTaxRiskReports)
      }
    }
  };


  useEffect(() => {
    if (currentTaxSheildReportId) {
      fetchSingleTaxReport(currentTaxSheildReportId);
    }
  }, [currentTaxSheildReportId]);

  const handleChangeTaxReportHandler = (event: any) => {
    const target = event.target.value;
    setCurrentTaxShieldReportId(target[0]);
    setReportDate({ Date: target[1], index: target[2] });
  };

  const handleNoticesChangePage = (event: unknown, newPage: number) => {
    setNoticePage(newPage);
  };

  const handleNoticesChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setNoticeRowsPerPage(parseInt(event.target.value, 10));
    setNoticePage(0);
  };

  const handleTaxLiablityChangePage = (event: unknown, newPage: number) => {
    setTaxLiabilityPage(newPage);
  };

  const handleTaxLiablityChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setTaxLiabilityRowsPerPage(parseInt(event.target.value, 10));
    setTaxLiabilityPage(0);
  };
  const riskIndicators = taxShieldReport?.RiskIndicators;
  const recentActivity = taxShieldReport?.RecentActivity;
  const noticeUpdates = taxShieldReport?.NoticesUpdates || [];
  const taxLiabilitiesByYear = taxShieldReport?.TaxLiabilitiesByYear;
  const TotalLiability = taxShieldReport?.TotalLiability;
  type RiskKey = 'AuditReview' | 'CollectionActivity' | 'NoticeUpdate' | 'FederalCompliance';

  const riskDescriptions: Record<RiskKey, {
    label: string;
    risk: string;
    noRisk: string;
  }> = {
    AuditReview: {
      label: 'Audit Status',
      risk: `IRS audit detected. This could result for various reasons, including underreported income, unusually large deductions, discrepancies in reported figures, or random selection under the IRS National Research Program. 
  
  Please gather all IRS correspondence and upload them to your client portal. 
  
  Did you know? In general, the IRS has up to three years from the date of filing to audit your tax return.`,
      noRisk: `We are pleased to report that there was no audit activity.
  
  Did you know? In general, the IRS has up to three years from the date of filing to audit your tax return.`,
    },
    CollectionActivity: {
      label: 'Collections Status',
      risk: `We detected your account is in collections. This means the IRS can take action to collect the balance due, including but not limited to placing liens, issuing levies, garnishing wages, and in certain cases, revoking your passport.
  
  If you received any notices or correspondence from the IRS regarding collections, please upload them to your client portal.
  
  Did you know? Even if your account is in IRS collections, you still have rights. The IRS must follow strict procedures and cannot collect more than what is legally owed. You may also qualify for payment plans or hardship relief to help manage your tax debt.`,
      noRisk: `This means you either have no balance due to the IRS or all tax years are in a formal agreement that protects you from any collection actions. 
  
  If you receive any future notices or correspondence from the IRS regarding collections, please upload them to your client portal.
  
  Did you know? Penalties and interest will continue to compound and accrue as long as there is an unpaid balance due to the IRS.`,
    },
    NoticeUpdate: {
      label: 'Notice Status',
      risk: `New IRS notices have been detected. Please monitor your mail for these notices.`,
      noRisk: `No new system notices detected on your account. 
  
  Important: Please note that not all IRS notices are captured on your account, so while we review it regularly, some notices will still be issued separately.`,
    },
    FederalCompliance: {
      label: 'Filing Status',
      risk: `We have detected that you have not filed all required federal tax returns. This means you are currently considered delinquent and past due, regardless of any valid extensions.
  
  Did you know? An extension to file doesn’t extend your payment deadline—taxes are still due by April 15th. Late filing can result in penalties of up to 4.5% per month on any unpaid taxes up to 22.5%.`,
      noRisk: `Congratulations! You are fully compliant with your federal tax filing requirements.
  
  Did you know? The IRS typically reviews the last six years of tax returns to determine if your filing history is compliant. If you’ve consistently filed and paid for those years, you’re generally considered in good standing with the IRS.`,
    },
  };
  

  const getTooltipText = (key: RiskKey) => {
    const isRisk = riskIndicators?.[key];
    return isRisk ? riskDescriptions[key].risk : riskDescriptions[key].noRisk;
  };

  const auditReviewIcon = () =>
    riskIndicators?.AuditReview ? (
      <Shieldhighrisk width={40} height={40} className="icon-class" />
    ) : (
      <Shieldlowrisk width={40} height={40} className="icon-class" />
    );
  const collectionActivityIcon = () =>
    riskIndicators?.CollectionActivity ? (
      <Shieldhighrisk width={40} height={40} className="icon-class" />
    ) : (
      <Shieldlowrisk width={40} height={40} className="icon-class" />
    );
  const noticeUpdateIcon = () =>
    riskIndicators?.NoticeUpdate ? (
      <Shieldhighrisk width={40} height={40} className="icon-class" />
    ) : (
      <Shieldlowrisk width={40} height={40} className="icon-class" />
    );
  const federalComplianceIcon = () =>
    riskIndicators?.FederalCompliance ? (
      <Shieldhighrisk width={40} height={40} className="icon-class" />
    ) : (
      <Shieldlowrisk width={40} height={40} className="icon-class" />
    );

  const riskIcon = riskIndicators
    ? RISk[riskIndicators?.OverallRisk || "Low"]
    : undefined;

    const riskIndicatorsArray = [
      {
        label: "AUDIT STATUS",
        icon: auditReviewIcon(),
        tooltip: getTooltipText("AuditReview"),
      },
      {
        label: "COLLECTION STATUS",
        icon: collectionActivityIcon(),
        tooltip: getTooltipText("CollectionActivity"),
      },
      {
        label: "NOTICE STATUS",
        icon: noticeUpdateIcon(),
        tooltip: getTooltipText("NoticeUpdate"),
      },
      {
        label: "FILING STATUS",
        icon: federalComplianceIcon(),
        tooltip: getTooltipText("FederalCompliance"),
      },
    ];

  const printreport = () => {
    const doc: any = document;
    const divContents: any = doc?.getElementById("report_container").innerHTML;
    const printWindow: any = window.open("", "", "height=500, width=500");
    printWindow.document.open();
    printWindow.document.write(`
                <html>
                <head>
                    <title>Print Div Content</title>
                    <style>
                        body { font-family: Arial, sans-serif; }
                        table { width: 100%; border-collapse: collapse; }
                        th, td { border: 1px solid #ddd; padding: 8px; }
                        th { background-color: #f4f4f4; }
                    </style>
                </head>
                <body>
                    
                    ${divContents}
                </body>
                </html>
            `);
    printWindow.document.close();
    printWindow.print();
  };

  const isProUser = () => {
    if (partnerProfile) return true;
    let enrollmentData = protectionPlanEnrollment?.subscriptionStatus ? protectionPlanEnrollment?.subscriptionStatus : "";

    switch (customerRole) {
      case CustomerRoleName.RetailCustomer:
        if(enrollmentData)
          return true;
        break;
      case CustomerRoleName.TaxPrepReferredCustomer:
        if(protectionPlanEnrollment?.subscriptionPlan === ProtectionPlanName.ProtectionPartnerMonitoring)
          return true;
        break;
      case CustomerRoleName.NonTaxPrepReferredCustomer:
        if(protectionPlanEnrollment?.subscriptionPlan !== ProtectionPlanName.Free)
          return true;
        break;
      case CustomerRoleName.TaxReliefGraduatedCustomer:
        if(enrollmentData)
          return true;
        break;
      default:
        if(enrollmentData){
          return true;
        }
    }
    return false;
  }

  const onTaxIdTheftAgreeHandler = (alertId:string) => {
    setProfileAlerts(profileAlerts.map((item:any) => item.ProfileAlertId === alertId?{...item, Active:false}:item))
    setShowConfirmModal(true);
  }

  const onTaxIdTheftDisagreeHandler = (alertId: string) => {
    setProfileAlerts(profileAlerts.map((item:any) => item.ProfileAlertId === alertId?{...item, Active:false}:item));
    fetchClientName();
    setShowDisagreeModal(true);
  }

  const onConfirmModalCloseHandler = () => {
    setShowConfirmModal(false);
  }

  const onConfirmModalAgreeHandler = () => {
    setShowConfirmModal(false);
    navigate(paths.dashboard.uploadTaxReturn);
  }

  const onActionHandler = (action: string) => {
    setShowDisagreeModal(false);
    if(action === 'get-help') {
      navigate(paths.settings.myaccount.changePlanEnrolment, {state: {from: 'taxIdTheftAlert'}});
      //navigate(paths.dashboard.taxShield.enrollment, {state: {action: 'changePlan'}});
    }else if(action === 'speak-with-agent'){
      navigate('/schedule-appointment', {state: {from: 'taxIdTheftAlert'}});
    }
  }

  const onNoticeClickHandler = (notice: any) => {
    setSelectedNotice(notice);
    setShowNoticeModal(true);
  }

  const onNoticeModalCloseHandler = () => {
    setSelectedNotice(null);
    setShowNoticeModal(false);
  }



  return (
    <>
   

      {showPlaceholder && !isLegacy ? (
        <PlaceholderReport clientName={clientName} />
      ) : (
        !isLegacy && (
        <Container sx={{ marginTop: "10px" }} id="report_container">
          <Grid
            container
            spacing={2}
            justifyContent={"space-between"}
            marginBottom={"10px"}
            paddingTop={"14px"}
            marginTop={0}
          >
            <Grid item sm={12} md={12} lg={6}>
              <Card sx={{ height: "100%" }}>
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  {isLoading ? (
                    <Skeleton width={"100%"} className="mt-3" />
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "32px 24px 16px 24px",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ padding: "0px 16px 0px 0px" }}>
                          <PersonIcon />
                        </div>
                        {isLoading ? (
                          <Skeleton />
                        ) : (
                          <Typography
                            variant="h6"
                            sx={{ fontWeight: "500", fontSize: "18px" }}
                          >
                            {clientName}
                          </Typography>
                        )}
                      </div>
                    </Box>
                  )}

                  {isLoading ? (
                    <Skeleton
                      circle
                      height={150}
                      className="w-50 d-block mx-auto mt-3"
                      containerClassName="avatar-skeleton"
                    />
                  ) : (
                    <img
                      src={riskIcon?.icon}
                      className="w-75 d-block mt-5 mx-auto mb-5"
                      alt="report"
                    />
                  )}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      paddingLeft: "40px",
                      paddingRight: "40px",
                    }}
                  >
                    <Typography
                      variant="h3"
                      padding={"5px"}
                      fontWeight={700}
                      fontSize={30}
                    >
                      {isLoading ? (
                        <Skeleton width={400} count={6} />
                      ) : (
                        `${riskIcon?.title ? `${riskIcon?.title} ` : ""}`
                      )}
                    </Typography>
                    <Typography
                      variant="body1"
                      textAlign={"center"}
                      color={"#667085"}
                      sx={{
                        fontSize: "14px",
                        textAlign: "center",
                        padding: "0px 0px 19px 0px ",
                      }}
                    >
                      {isLoading ? (
                        <></>
                      ) : (
                        <>
                          {riskIcon?.nextStep}
                        </>
                      )}
                    </Typography>
                  </Box>
                  {isLoading ? (
                    <Skeleton
                      width={400}
                      count={6}
                      style={{ marginLeft: "10%" }}
                    />
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "5px",
                        paddingLeft: "40px",
                        paddingRight: "40px",
                      }}
                    >
                      {riskIndicators?.OverallRisk === "High" ? (
                        <Typography
                          fontSize={16}
                          fontWeight={600}
                          textAlign={"center"}
                          padding={"5px"}
                        >
                          <strong style={{ marginRight: 5 }}>
                            {isLoading ? (
                              <Skeleton width={400} count={3} />
                            ) : (
                              `OUR RECOMMENDATION`
                            )}
                          </strong>
                        </Typography>
                      ) : (
                        <></>
                      )}
                      {riskIndicators?.OverallRisk === "High" ? (
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: "14px",
                            textAlign: "center",
                            padding: "0px 0px 19px 0px",
                            color: "#667085",
                          }}
                        >
                          {isLoading ? (
                            <Skeleton />
                          ) : (
                            <span>
                              <strong>We strongly recommend that you</strong> please
                              contact {partnerName} at {phoneNumber} immediately
                              to discuss your options.
                            </span>
                          )}
                        </Typography>
                      ) : (
                        <></>
                      )}
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>

            <Grid item sm={12} md={12} lg={6}>
              {!isProUser() &&
                <Grid paddingBottom={"24px"}>
                  <Box
                    sx={{
                      display: "flex",
                      padding: "6px 16px",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderRadius: "8px",
                      background: "#1D89D2",
                    }}
                  >
                    <Box paddingRight={"12px"}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M10.084 6.41732H11.9173V8.25065H10.084V6.41732ZM10.084 10.084H11.9173V15.584H10.084V10.084ZM11.0007 1.83398C5.94065 1.83398 1.83398 5.94065 1.83398 11.0007C1.83398 16.0607 5.94065 20.1673 11.0007 20.1673C16.0607 20.1673 20.1673 16.0607 20.1673 11.0007C20.1673 5.94065 16.0607 1.83398 11.0007 1.83398ZM11.0007 18.334C6.95815 18.334 3.66732 15.0431 3.66732 11.0007C3.66732 6.95815 6.95815 3.66732 11.0007 3.66732C15.0431 3.66732 18.334 6.95815 18.334 11.0007C18.334 15.0431 15.0431 18.334 11.0007 18.334Z"
                          fill="white"
                        />
                      </svg>
                    </Box>
                    <Typography sx={{ fontSize: "14px", color: "#FFFFFF" }}>
                      Upgrade your plan to gain access to Optima's full suite of
                      benefits.
                    </Typography>
                    <Button
                      sx={{
                        borderRadius: "8px",
                        color: "#FFFFFF",
                        fontWeight: 700,
                        fontSize: "14px",
                        padding: "4px 10px",
                        border: " 1px solid #FFFFFF",
                      }}
                      onClick={() =>
                        navigate(paths.dashboard.taxShield.enrollment)
                      }
                    >
                      Upgrade
                    </Button>
                  </Box>
                </Grid>
              }
              <Grid>
                <Card className="border-0" sx={{ marginBottom: "30px" }}>
                  <CardContent>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        color: "#667085",
                      }}
                    >
                      <div style={{ marginLeft: "100%" }}>
                        {isLoading ? (
                          <Skeleton />
                        ) : (
                          <PrintOutlinedIcon onClick={printreport} />
                        )}
                      </div>
                      {isLoading && singleReportLoading ? (
                        <Skeleton width={400} />
                      ) : (
                        <Select
                          sx={{
                            width: "70%",
                            marginTop: "10px",
                            boxShadow: "0px 1px 2px 0px #00000014",
                            border: "1px solid #1D89D2",
                            backgroundColor: "#F0F7FC",
                            padding: "20px 12px",
                            textAlign: "center",
                            ".MuiSelect-select": {
                              display: "flex",
                              justifyContent: "center",
                            },
                          }}
                          value={reportDate}
                          onChange={handleChangeTaxReportHandler}
                          renderValue={(selected) =>
                            `${dateformat(selected?.Date)} ${
                              selected?.index === 0 ? "(Latest)" : ""
                            }`
                          }
                        >
                          {allTaxShieldReports?.map(
                            (report: any, index: any) => {
                              return (
                                <MenuItem
                                  key={report.Id}
                                  value={[report.Id, report.ReportDate, index]}
                                >
                                  {dateformat(report.ReportDate)}
                                  {index === 0 && " (Latest)"}
                                </MenuItem>
                              );
                            }
                          )}
                        </Select>
                      )}
                      <Typography variant="body1" sx={{ padding: "1.5rem" }}>
                        Total Estimated Federal Liability *
                      </Typography>
                      {isLoading ? (
                        <Skeleton width={400} count={3} />
                      ) : (
                        <Typography
                          sx={{
                            fontSize: "60px",
                            lineHeight: "68px",
                            fontWeight: 800,
                            color: "#F84562",
                          }}
                        >
                          {formatCurrency(TotalLiability?.Amount)}
                        </Typography>
                      )}
                      <Typography variant="body1" sx={{ padding: "1.5rem" }}>
                        Balances are subject to daily penalities and interest.
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
                <Card className="border-0">
                  <CardContent
                    sx={{
                      padding: "30px, 24px, 24px, 24px",
                      gap: "16px",
                      color: "#667085",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: "600",
                          fontSize: "18px",
                          marginTop: "8px",
                          color: "black",
                        }}
                      >
                        RECENT ACTIVITY
                      </Typography>
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignContent: "center",
                          justifyContent: "space-between",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        {isLoading ? (
                          <Skeleton width={450} />
                        ) : (
                          <>
                            <Typography
                              variant="body2"
                              className="recent-activity-title"
                            >
                              Type
                            </Typography>
                            <Typography
                              variant="body2"
                              className="recent-activity-description"
                            >
                              {recentActivity?.Type || "-"}
                            </Typography>
                          </>
                        )}
                      </Box>
                      <Divider
                        variant="fullWidth"
                        sx={{
                          borderColor: "rgba(0, 0, 0, 0.12)",
                          width: "100%",
                          marginY: 1,
                        }}
                      />
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignContent: "center",
                          justifyContent: "space-between",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        {isLoading ? (
                          <Skeleton width={450} />
                        ) : (
                          <>
                            <Typography
                              variant="body2"
                              className="recent-activity-title"
                            >
                              Amount
                            </Typography>
                            <Typography
                              variant="body2"
                              className="recent-activity-description"
                            >
                              {formatCurrency(
                                taxShieldReport?.RecentActivity?.Amount
                              ) || "-"}
                            </Typography>
                          </>
                        )}
                      </Box>
                      <Divider
                        variant="fullWidth"
                        sx={{
                          borderColor: "rgba(0, 0, 0, 0.12)",
                          width: "100%",
                          marginY: 1,
                        }}
                      />
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignContent: "center",
                          justifyContent: "space-between",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        {isLoading ? (
                          <Skeleton width={450} />
                        ) : (
                          <>
                            <Typography
                              variant="body2"
                              className="recent-activity-title"
                            >
                              Tax Year
                            </Typography>
                            <Typography
                              variant="body2"
                              className="recent-activity-description"
                            >
                              {taxShieldReport?.RecentActivity?.TaxYear || "-"}
                            </Typography>
                          </>
                        )}
                      </Box>
                      <Divider
                        variant="fullWidth"
                        sx={{
                          borderColor: "rgba(0, 0, 0, 0.12)",
                          width: "100%",
                          marginY: 1,
                        }}
                      />
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignContent: "center",
                          justifyContent: "space-between",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        {isLoading ? (
                          <Skeleton width={450} />
                        ) : (
                          <>
                            <Typography className="recent-activity-title">
                              Date Recieved
                            </Typography>
                            <Typography
                              variant="body2"
                              className="recent-activity-description"
                            >
                              {taxShieldReport?.RecentActivity?.DateReceived ||
                                "-"}
                            </Typography>
                          </>
                        )}
                      </Box>
                      <Divider
                        variant="fullWidth"
                        sx={{
                          borderColor: "rgba(0, 0, 0, 0.12)",
                          width: "100%",
                        }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          width: "100%",
                          alignItems: "center",
                          padding: "0.5rem",
                        }}
                      >
                        <Box>
                          <Typography variant="body2" textAlign={"center"}>
                            It may take up to 2 business days after the funds
                            have been drafted for your payment to post to your account.
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            justifyContent={"space-between"}
            marginBottom={"10px"}
          >
            {riskIndicatorsArray.length &&
              riskIndicatorsArray.map((item, index) => (
                <Grid key={index} item xs={12} md={6} sm={12} lg={3}>
                  <CustomTooltip
                    title={item.tooltip}
                    placement="top"
                    arrow
                  >
                  <Card
                    sx={{
                      paddingBottom: "0px",
                      height: "100%",
                      display: "flex",
                    }}
                  >
                    <CardContent
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: "24px 20px",
                        paddingBottom: "24px !important",
                      }}
                    >
                      {isLoading ? (
                        <Skeleton width={225} />
                      ) : (
                        <>
                          <div style={{ height: "40px", width: "40px" }}>
                            {item.icon}
                          </div>
                          <Typography
                            sx={{
                              marginLeft: "10px",
                              fontWeight: 600,
                              color: "#212636",
                              fontSize: "18px",
                            }}
                          >
                            {item.label}
                          </Typography>
                        </>
                      )}
                    </CardContent>
                  </Card>
                  </CustomTooltip>
                </Grid>
              ))}
          </Grid>

          <Grid
            container
            spacing={2}
            justifyContent={"space-between"}
            marginBottom={"10px"}
          >
            <Grid item xs={12} sm={12} md={12} lg={6}>
              <Card sx={{ height: "100%" }}>
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "stretch",
                    alignItems: "center",
                    paddingBottom: 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      padding: "10px",
                      fontSize: "18px",
                      textAlign: "center",
                      color: "rgba(33, 38, 54, 1)",
                    }}
                  >
                   RECENT NOTICES & UPDATES
                  </Typography>
                  <TableContainer
                    sx={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    <Table aria-label="sticky table">
                      <TableHead
                        sx={{
                          ".MuiTableCell-root": {
                            backgroundColor: "#EDF7FF",
                            color: "#667085",
                            padding: "1rem",
                          },
                        }}
                      >
                        <TableRow>
                          <TableCell
                            align="left"
                            className="table-cell"
                            colSpan={2}
                          >
                            TAX YEAR
                          </TableCell>
                          <TableCell align="left" colSpan={3}>
                            NOTICE TYPE
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {noticeUpdates?.length > 0 ? (
                          noticeUpdates
                            .slice(
                              noticePage * noticeRowsPerPage,
                              noticePage * noticeRowsPerPage + noticeRowsPerPage
                            )
                            .map((Notice, index) => (
                              <TableRow key={index}>
                                <TableCell align="left" colSpan={2}>
                                  {isLoading ? <Skeleton /> : Notice.TaxYear}
                                </TableCell>
                                <TableCell align="left" colSpan={3}>
                                  {isLoading ? <Skeleton /> : <a className="notice-type-link" onClick={() => onNoticeClickHandler(Notice)}>{Notice.NoticeIssued}</a>}
                                </TableCell>
                              </TableRow>
                            ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={5} align="center">
                              {isLoading ? (
                                <Skeleton />
                              ) : (
                                "No notices available"
                              )}
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {noticeUpdates && noticeUpdates?.length > 0 ? (
                    <TablePagination
                      rowsPerPageOptions={[3, 6]}
                      component="div"
                      sx={{
                        display: "flex",
                        justifyContent: "space-around",
                        width: "100%",
                        ".MuiTablePagination-toolbar": {
                          padding: 0,
                        },
                        ".MuiTablePagination-actions": {
                          marginRight: "10px",
                          marginLeft: "16px",
                        },
                        ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
                          {
                            marginBottom: "0",
                          },
                        ".MuiTablePagination-select": {
                          padding: "4px 8px",
                          backgroundColor: "#fff",
                          borderColor: "#e0e0e0",
                        },
                        ".MuiTablePagination-input": {
                          fontSize: "0.875rem",
                          marginRight: "10px",
                        },
                      }}
                      count={noticeUpdates?.length || 0}
                      rowsPerPage={noticeRowsPerPage}
                      page={noticePage}
                      onPageChange={handleNoticesChangePage}
                      onRowsPerPageChange={handleNoticesChangeRowsPerPage}
                    />
                  ) : (
                    <></>
                  )}
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={6}>
              <Card sx={{ height: "100%" }}>
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "stretch",
                    alignItems: "center",
                    paddingBottom: 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      padding: "10px",
                      fontSize: "18px",
                      textAlign: "center",
                      color: "rgba(33, 38, 54, 1)",
                    }}
                  >
                    FEDERAL TAX LIABILITY BY YEAR
                  </Typography>
                  <TableContainer
                    sx={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    <Table aria-label="sticky table">
                      <TableHead
                        sx={{
                          ".MuiTableCell-root": {
                            backgroundColor: "#EDF7FF",
                            color: "#667085",
                            padding: "1rem",
                          },
                        }}
                      >
                        <TableRow>
                          <TableCell align="left" colSpan={2}>
                            TAX YEAR
                          </TableCell>
                          <TableCell align="left" colSpan={2}>
                            CURRENT BALANCE
                          </TableCell>
                          <TableCell align="left" colSpan={2}>
                            FILING STATUS
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {taxLiabilitiesByYear &&
                        taxLiabilitiesByYear?.length ? (
                          taxLiabilitiesByYear
                            .slice(
                              taxLiabilityPage * taxLiabilityRowsPerPage,
                              taxLiabilityPage * taxLiabilityRowsPerPage +
                                taxLiabilityRowsPerPage
                            )
                            .map((taxLiablitity, index) => (
                              <TableRow tabIndex={-1} key={index}>
                                <TableCell align="left" colSpan={2}>
                                  {isLoading ? (
                                    <Skeleton />
                                  ) : (
                                    taxLiablitity.TaxYear
                                  )}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  colSpan={2}
                                  sx={{
                                    color: taxLiablitity.CurrentBalance
                                      ? "#F84562"
                                      : "",
                                    fontWeight: taxLiablitity.CurrentBalance
                                      ? 700
                                      : 400,
                                  }}
                                >
                                  {isLoading ? (
                                    <Skeleton />
                                  ) : (
                                    formatCurrency(taxLiablitity.CurrentBalance)
                                  )}
                                </TableCell>
                                <TableCell align="left" colSpan={2}>
                                  {isLoading ? (
                                    <Skeleton />
                                  ) : (
                                    taxLiablitity.FilingStatus
                                  )}
                                </TableCell>
                              </TableRow>
                            ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={5} align="center">
                              {isLoading ? <Skeleton /> : "No Tax available"}
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {taxLiabilitiesByYear && taxLiabilitiesByYear?.length ? (
                    <TablePagination
                      rowsPerPageOptions={[3, 6]}
                      component="div"
                      sx={{
                        display: "flex",
                        justifyContent: "space-around",
                        width: "100%",
                        ".MuiTablePagination-toolbar": {
                          padding: 0,
                        },
                        ".MuiTablePagination-actions": {
                          marginRight: "10px",
                          marginLeft: "16px",
                        },
                        ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
                          {
                            marginBottom: "0",
                          },
                        ".MuiTablePagination-select": {
                          padding: "4px 8px",
                          backgroundColor: "#fff",
                          borderColor: "#e0e0e0"
                        },
                        ".MuiTablePagination-input": {
                          fontSize: "0.875rem",
                          marginRight: "10px",
                        },
                      }}
                      count={taxLiabilitiesByYear?.length || 0}
                      rowsPerPage={taxLiabilityRowsPerPage}
                      page={taxLiabilityPage}
                      onPageChange={handleTaxLiablityChangePage}
                      onRowsPerPageChange={handleTaxLiablityChangeRowsPerPage}
                    />
                  ) : (
                    <></>
                  )}
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          {taxShieldReport?.UsesHistoricalData &&
            <Grid2 component='div' size={12} mt={2} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Typography sx={{ fontSize: '10px' }}>
              This report reflects the most recent information available from the IRS. If you have any questions or concerns, please contact your representative.
            </Typography>
          </Grid2>}
          <Grid item xs={12} sm={12} md={12} lg={12} mt={2} sx={{display: 'flex',justifyContent: 'center'}}>
            <Typography sx={{fontSize: '10px'}}>The above summary excludes balances due to penalties for not having health insurance and Separate Assessments made by the IRS (split or transferred assessments on joint tax liabilities).</Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{display: 'flex',justifyContent: 'center'}}>
            <Typography sx={{fontSize: '10px'}}>Note that your spouse’s tax situation may not be fully reflected if filed separately.</Typography>
          </Grid>
            
         {!reportId && <Grid mt={5}>
            <TermSentence style={{ zIndex: 10, fontSize: 12 }} className="media-term-text">
              Copyright © Optima Tax Relief, LLC | All Rights Reserved
              <Dot>•</Dot>
              <ForgotPasswordLink
                href="https://optimataxrelief.com/about-us/terms-of-site/"
                target="_blank"
                rel="noreferrer"
                className="media-term-text"
              >
                Terms & Conditions{" "}
              </ForgotPasswordLink>
              <Dot>•</Dot>
              <ForgotPasswordLink
                href="https://optimataxrelief.com/about-us/privacy/"
                target="_blank"
                rel="noreferrer"
                className="media-term-text"
              >
                Privacy Policy
              </ForgotPasswordLink>
            </TermSentence>
          </Grid>}
        </Container>
        )
      )}
        {legacyTaxReports.length > 0 && <LegacyReports clientName={clientName} legacyTaxReports={legacyTaxReports} />}
        {showNoticeModal && <NoticeDisplayModal notice={selectedNotice} onClose={onNoticeModalCloseHandler} open={showNoticeModal}/>}
        {(profileAlerts && profileAlerts.length > 0) && 
          profileAlerts.map((profileAlert:any) => {
            return <TaxIdTheftAlertModal alertData={profileAlert} onAgree={onTaxIdTheftAgreeHandler} onDisagree={onTaxIdTheftDisagreeHandler} open={profileAlert.Active} /> 
          }) 
        }
        {showConfirmModal && <TaxIdTheftConfirmationModal onUploadClick={onConfirmModalAgreeHandler} onClose={onConfirmModalCloseHandler} open={showConfirmModal} /> }
        {showDisagreeModal && 
        <>
          {
          profileData?.EnrollmentSource === "Referral"?
          <TaxReturnNotFilingReferralModal onAction={onActionHandler} partnerName={partnerName} phoneNumber={phoneNumber} open={showDisagreeModal} />
          :<>{(protectionPlanEnrollment?.subscriptionPlan === ProtectionPlanName.Standard
                || protectionPlanEnrollment?.subscriptionPlan === ProtectionPlanName.Premium
                || protectionPlanEnrollment?.subscriptionPlan === ProtectionPlanName.Professional)?
          <TaxReturnNotFilingSubscriberModal onAction={onActionHandler} planName={protectionPlanEnrollment?.subscriptionPlan} open={showDisagreeModal} />
          :<TaxReturnNotFilingModal onAction={onActionHandler} open={showDisagreeModal} />}
          </>
          }
        </>
        }
                
    </>
  );
};

export default TaxShieldReports;

const TermSentence = styled.div`
  align-items: center;
  text-align: center;
  margin: 2rem 1rem 2rem;
  color: #8E8E93;
`;

const ForgotPasswordLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  margin-left: 3px;
  color: #1D89D2;
`;

const Dot = styled.span`
  margin-left: 3px;
`;
